/** Forward search → PDP page crossfade duration. */
export const PDP_FORWARD_TRANSITION_MS = 500;

/** Card image + content shared-element expand duration. */
export const PDP_EXPAND_TRANSITION_MS = 500;

export const PDP_EXPAND_EASING = "cubic-bezier(0.32, 0.72, 0, 1)";
